<div class="d-flex h-100 justify-content-center align-items-center">
    <h1>{{sessionExpiredDueToInactivityMessage}}</h1>
</div>